(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/behaviors/lotto-rule-change-info.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/behaviors/lotto-rule-change-info.js');

'use strict';

svs.lotto.components.play.behaviors.lottoRuleChangeInfo = Marionette.Behavior.extend({
  ui: {
    showFullscreenInfo: '#show-fullscreen-info'
  },
  events: {
    'click @ui.showFullscreenInfo': 'onShowFullscreenInfoClick'
  },
  modelEvents: {
    'change:drawCount': 'onUpdateShowInfo',
    'change:selectedDays': 'onUpdateShowInfo'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent
  }],
  onInitialize() {
    this.firstPlayableDraw = svs.numbergames.draws.drawsApi.firstPlayableDraw(this.view.model.get('productId'));
    const {
      productId: product,
      drawNumber
    } = this.firstPlayableDraw[svs.numbergames.game.draw.upcomingDrawProduct];
    this.isNewRules = svs.numbergames.rules.utils.lotto.isNewRules({
      product,
      drawNumber
    });
    this.handleNavigationChange = this.handleNavigationChange.bind(this);
    window.addEventListener('popstate', this.handleNavigationChange);
  },
  onRender() {
    this.onUpdateShowInfo();
  },
  showInfo() {
    const isNewRules = this.isNewRules;
    this.view.showChildView(this.options.ruleChangeInfoRegionSelector, {
      template() {
        return svs.lotto.components.play.templates.lotto_rule_change_info({
          isNewRules
        });
      }
    });
  },
  hideInfo() {
    var _this$view$getChildVi, _this$view$getChildVi2;
    this.removeFullscreen();
    (_this$view$getChildVi = this.view.getChildView(this.options.ruleChangeInfoRegionSelector)) === null || _this$view$getChildVi === void 0 || (_this$view$getChildVi2 = _this$view$getChildVi.destroy) === null || _this$view$getChildVi2 === void 0 || _this$view$getChildVi2.call(_this$view$getChildVi);
  },
  handleNavigationChange() {
    if (history.state && history.state.fullscreen) {
      this.showFullscreen();
    } else {
      this.removeFullscreen();
      history.replaceState({}, '', window.location.pathname);
    }
  },
  showFullscreen() {
    const container = document.getElementById('lotto-fullscreen-container');
    if (container) {
      document.body.style.overflow = 'hidden';
      ReactDOM.render(React.createElement(svs.components.onboarding.widgetAreaFullscreen.WidgetAreaFullscreen, {
        onCloseFullscreen: () => {
          history.replaceState({}, '', window.location.pathname);
          this.handleNavigationChange();
        },
        widgetAreaName: 'lottoFullscreenWidgetArea',
        branding: 'lotto'
      }), container);
    }
  },
  onUpdateShowInfo() {
    var _this$firstPlayableDr;
    let productItsId;
    if (this.view.model.get('selectedDays').length === 1) {
      productItsId = this.view.model.get('selectedDays')[0];
    } else {
      productItsId = svs.numbergames.game.draw.upcomingDrawProduct;
    }
    const draw = (_this$firstPlayableDr = this.firstPlayableDraw[productItsId]) !== null && _this$firstPlayableDr !== void 0 ? _this$firstPlayableDr : {};
    const isShowRuleChangeInfo = svs.numbergames.rules.utils.lotto.showRuleChangeInfo({
      product: productItsId,
      firstDraw: draw.drawNumber,
      lastDraw: draw.drawNumber + parseInt(this.view.model.get('drawCount'), 10) - 1
    });
    if (isShowRuleChangeInfo || this.view.model.get('isSubscription') && svs.core.detect.feature('ft-lotto-rule-change')) {
      this.showInfo();
    } else {
      this.hideInfo();
    }
  },
  onShowFullscreenInfoClick() {
    if (!history.state || !history.state.fullscreen) {
      history.pushState({
        fullscreen: true
      }, '', '');
    }
    this.showFullscreen();
  },
  removeFullscreen() {
    const container = document.getElementById('lotto-fullscreen-container');
    if (container) {
      document.body.style.overflow = 'visible';
      ReactDOM.unmountComponentAtNode(container);
      container.innerHTML = '';
    }
  }
});

 })(window);